$(window).on('load', () => {
  AOS.init({
    offset: jQuery(window).height() * 0.1,
  });
  const header = document.querySelector('header');
  const toTop = document.getElementById('top');

  window.addEventListener('scroll', function (e) {
    let scrollPosition = window.scrollY;
    if (+scrollPosition > 40) {
      if (!header.classList.contains('scrolled')) {
        header.classList.add('scrolled');
      }
      if (!toTop.classList.contains('scrolled')) {
        toTop.classList.add('backtotop--visible');
      }
    } else {
      header.classList.remove('scrolled');
      toTop.classList.remove('backtotop--visible');
    }
  });

  toTop.onclick = function(e){
    e.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  $('#mainHamburger').on('click', function(e) {
    $('#mobileMenu').toggleClass('active');
    $('#mainHamburger').toggleClass('active');
    $('body').toggleClass('mm-active');

    if (!header.classList.contains('scrolled') && !header.classList.contains('header--transparent')) {
      header.classList.toggle('shadow');
    }
  })

  $('#mobileMenu a').on('click', function() {
    $('#mobileMenu').removeClass('active');
    $('#mainHamburger').removeClass('active');
    $('body').toggleClass('mm-active');
  })
});

$( window ).resize(function() {
  if ($(window).width() > 992) {
    $('#mobileMenu').removeClass('active');
    $('#mainHamburger').removeClass('active');
    $('body').removeClass('mm-active');
  } 
});
